import { migration as initial } from "./001_initial";
import { migration as tenantProviders } from "./002_tenant_providers";

export const migrations = [initial, tenantProviders];
